import { Button, Drawer, List, Tooltip, } from 'antd';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector, useAuth } from '../../store/hooks';
import { collection, onSnapshot, query, where, orderBy, limit } from 'firebase/firestore';
import { db } from '../../config/firebase-config';
import { Job, setJobs } from '../../store/jobSlice';
import { LoadingOutlined, ScheduleOutlined } from '@ant-design/icons';
import JobListItem from './JobListItem';
import { JobStatus } from '../../constants/status';

const JobDrawer: React.FC = () => {
    const dispatch = useAppDispatch()
    const { currentUser, loading } = useAuth()
    const userId = currentUser?.uid
    const selectedCompany = useAppSelector((state) => state.companies.selectedCompany)
    const companyId = selectedCompany?.id
    const jobs = useAppSelector((state) => state.jobs.jobs)

    const [open, setOpen] = useState(false);

    const showDrawer = () => setOpen(true);
    const closeDrawer = () => setOpen(false);

    const hasActiveJobs = jobs.some(job => [JobStatus.PENDING, JobStatus.IN_PROGRESS].includes(job.status));

    useEffect(() => {
        if (companyId && userId) {
            const q = query(
                collection(db, "companies", companyId, "jobs"),
                where("userId", "==", userId),
                orderBy("createdAt", "desc"),
                limit(10)
            )

            const unsubscribe = onSnapshot(q, (snapshot) => {
                console.log("📡 Subscribing to jobs listener...");
                const updatedJobs = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                } as Job));
                // Update Redux state with the new data
                dispatch(setJobs(updatedJobs));
            }, (error) => {
                console.error("Error fetching real-time updates: ", error);
            });

            return () => {
                console.log("🧹 Unsubscribing from jobs listener...");
                unsubscribe();
            }
        }
    }, [companyId, userId, dispatch]);

    return (
        <>
            <Tooltip title={hasActiveJobs ? "Jobs in Progress" : "View Jobs"}>
                <Button
                    type={hasActiveJobs ? "primary" : "default"}
                    icon={hasActiveJobs ? <LoadingOutlined spin /> : <ScheduleOutlined />}
                    onClick={showDrawer}
                />
            </Tooltip>
            <Drawer
                title="Current Jobs"
                placement="right"
                width={400}
                onClose={closeDrawer}
                open={open}
            >
                <List
                    itemLayout="vertical"
                    dataSource={jobs}
                    renderItem={(job) => (
                        <JobListItem job={job} />
                    )}
                />
            </Drawer>
        </>
    );
};

export default JobDrawer;